module.exports = __webpack_public_path__ + "static/media/mobile.c6ccc384.svg";